import React, { useState, useEffect, useRef } from "react";
import ReportCount from "../reports/ReportCount";
import FieldOptionReportIcon from "./FieldOptionReportIcon";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";
import wNumb from "wnumb";
import htmlToLabel from "../../utils/htmlToLabel";

const FieldOptionValueReport = (props) => {
  const element = props.element;
  const field = props.field;
  const field_option = props.field_option;
  const idPrefix = props.reportIdPrefix || "";

  let field_option_formatted_value = field_option.value;

  if (field.field_type == "range" && !isNaN(field_option.value)) {
    const formatPercentage = wNumb({
      decimals: 0,
      suffix: "%",
    });

    const formatCurrency = wNumb({
      decimals: 2,
      prefix: props.currency,
    });

    var numberType = field.options["range-value-type"]
      ? field.options["range-value-type"]
      : "integer";
    if (numberType == "integer") {
      field_option_formatted_value = parseInt(field_option.value);
    } else if (numberType == "currency") {
      field_option_formatted_value = formatCurrency.to(
        parseInt(field_option.value)
      );
    } else if (numberType == "percentage") {
      field_option_formatted_value = formatPercentage.to(
        parseInt(field_option.value)
      );
    }
  }

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report field-option-report"
        data-field-id={field.id}
        data-report-id-prefix={idPrefix}
      >
        <div
          className="element-selection-report-bar"
          style={{
            width: undefined,
            display: "none",
          }}
        ></div>
        <div className="row hard-center funnel-breakdown-item-row">
          <div className="col-xs-4 funnel-breakdown-question-label">
            <p className="ellipsis" style={{ marginBottom: "5px" }}>
              <span className="funnel-breakdown-question-position">
                <FieldOptionReportIcon
                  field_type={field.field_type}
                  field_option={field_option}
                />
              </span>
              <span
                className="funnel-breakdown-question-text"
                style={{ display: "inline-block" }}
                dangerouslySetInnerHTML={{
                  __html: field_option.label
                    ? htmlToLabel(field_option.label)
                    : field_option_formatted_value
                    ? field_option_formatted_value
                    : `Field Option ${field_option.position}`,
                }}
              />
            </p>
          </div>
          <div className="col-xs-8 right">
            <p className="light text-xl" style={{ marginBottom: "10px" }}>
              <strong>
                <ReportCount
                  inline={true}
                  id={`${idPrefix}field-option-report-${field_option.id}`}
                  path={`/websites/${props.cta.website_id}/events_reports`}
                  payload={{
                    report_type: "distinct_count",
                    report: {
                      website_id: props.cta.website_id,
                      event_type:
                        element.element_type == "quiz"
                          ? "Selection"
                          : "Complete",
                      contactable_type: "Cta",
                      contactable_id: props.cta.id,
                      variant_id: props.step.variant_id,
                      step_id: props.step.id,
                      element_id: element.id,
                      field: field.report_keys,
                      value: field_option_formatted_value,
                      range_start: props.range_start,
                      range_end: props.range_end,
                    },
                  }}
                  callback={() => {
                    props.calculateSelectionRates();
                  }}
                />
              </strong>{" "}
              selected (<span className="conversion-rate">0.00</span>%)
              <FunnelTrackedMetrics
                layout="details"
                idBase={`${idPrefix}field_option-${field_option.id}`}
                selectionsId={`${idPrefix}field-option-report-${field_option.id}`}
                path={`/websites/${props.cta.website_id}/events_reports`}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                report={{
                  website_id: props.cta.website_id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: props.step.variant_id,
                  step_id: props.step.id,
                  element_id: element.id,
                  field: field.report_keys,
                  value: field_option_formatted_value,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FieldOptionValueReport;
